import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { StatsService } from '../../providers/stats.service';
import * as Highcharts from 'highcharts';
import BaseStats from '../base-stats';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { SecondsToDHMPipe } from "../../../common/pipes/seconds-to-DHM-pipe";
import { AccentHour } from "../../../common/models/stats/accent-hour";
import { StatsPieChartComponent } from "../../components/stats-pie-chart/stats-pie-chart.component";
import { MetricsItemComponent } from "../../components/metrics-item/metrics-item";
import { StatsEmptyComponent } from "../../components/stats-empty/stats-empty.component";
import { NgForOf, NgIf, PercentPipe } from "@angular/common";

@Component({
  selector: 'app-hours-per-accents-performed-container',
  templateUrl: './hours-per-accents-performed-container.component.html',
  styleUrls: ['./hours-per-accents-performed-container.scss', '../../components/metrics-item/metrics-item-list.scss'],
  standalone: true,
  imports: [
    StatsPieChartComponent,
    MetricsItemComponent,
    StatsEmptyComponent,
    NgForOf,
    NgIf,
    PercentPipe,
    SecondsToDHMPipe
  ],
  providers: [StatsService, SecondsToDHMPipe]
})
export class HoursPerAccentsPerformedContainerComponent extends BaseStats implements OnInit, OnDestroy {

    public accents: AccentHour[] = [];
    public accentsLoaded: EventEmitter<any> = new EventEmitter();
    private subscriptions: Subscription[] = [];

    constructor(
        private statsProvider: StatsService,
        private dmsPipe: SecondsToDHMPipe,
        private translater: TranslateService,
    ) {
        super();
    }

    public ngOnInit(): void {
        const self = this;

        this.subscriptions.push(
            this.accentsLoaded.subscribe((accents: AccentHour[]) => {
                const accentsData = accents.map((accent) => ({
                    name: accent.name,
                    y: this.percent(accent.seconds, accent.totalSecond),
                    color: accent.color,
                    seconds: accent.seconds
                })).filter((accent) => accent.y > 0);
                this.options = {
                    tooltip: {
                        pointFormatter(this: any): string {
                            return '<strong>' + Highcharts.numberFormat(this.y, 1) + ' %</strong><br />' +
                                '<strong>' + self.dmsPipe.transform(this.options.seconds, true) + '</strong>'
                            ;
                        }
                    },
                    series: [{
                        data: accentsData
                    }]
                };
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    protected populateData() {
        this.subscriptions.push(
            this.statsProvider.getAccentsHoursPerformedDataByDate(this.organization, this.athlete, this.dateFrom, this.dateTo).subscribe((accents) => {
                this.accents = accents;
                this.loaded = true;
                this.accentsLoaded.emit(accents);
            })
        );
    }

    protected getTitle() {
        return 'StatsAccentsHours';
    }
}
